export default __webpack_public_path__ + "static/Poppins-Bold-d1c550e43ca6e696c7875d532203b976.woff";